import { createContext, useReducer } from "react";
import axios from "axios";
import { API_URL_ASSORTMENT_HIERARCY } from "../../utils/apiURL";

export const assortmentHierarcyContext = createContext();

const INTIAL_STATE = {
  assortment: null,
  assortmentHierarcy: [],
  error: null,
  loading: false,
  token: null,
  searchResult: [],
  departments: [],
  SingleRow: [],
  rowdel: null,
};

const assortmentHierarcyReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "Fetch_success":
      return {
        ...state,
        loading: false,
        assortmentHierarcy: payload,
      };
    case "Fetch_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Add_success":
      return {
        ...state,
        loading: false,
        assortment: payload,
      };
    case "Add_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Delete_success":
      return {
        ...state,
        loading: false,
        rowdel: payload,
      };
    case "Delete_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Department_success":
      return {
        ...state,
        loading: false,
        departments: payload,
      };
    case "Department_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Search_success":
      return {
        ...state,
        loading: false,
        searchResult: payload,
      };
    case "Search_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case "Single_success":
      return {
        ...state,
        loading: false,
        SingleRow: payload,
      };
    case "Single_fail":
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export const AssortmentHierarcyContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(assortmentHierarcyReducer, INTIAL_STATE);

  // GetAllAssortment API
  const fetchAssortmentHierarcyAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_ASSORTMENT_HIERARCY}/GetAllAssortment`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Fetch_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Fetch_fail",
        payload: error,
      });
    }
  };

  // AddUpdateAssortment API
  const addUpdateAssortmentHierarcyAction = async (assortmentData, tokenVal, history) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      //request
      const res = await axios.post(
        `${API_URL_ASSORTMENT_HIERARCY}/AddUpdateAssortment`,
        assortmentData,
        config
      );

      //dispatch
      if (res?.request.status === 200) {
        dispatch({
          type: "Add_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      history.push("/asssortment");

    } catch (error) {
      dispatch({
        type: "Add_fail",
        payload: error,
      });
      alert(error.message);
    }
  };

  // DeleteAssortment API
  const deleteAssortmentHierarcyAction = async (id, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_ASSORTMENT_HIERARCY}/DeleteAssortment?Id=${id}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Delete_success",
          payload: res?.data,
        });
      }
      alert(res?.data);
      fetchAssortmentHierarcyAction(tokenVal);
      // window.location.href = "/asssortment";
    } catch (error) {
      dispatch({
        type: "Delete_fail",
        payload: error,
      });
    }
  };

  // GetAllDepartment API
  const getDepartmentAssortmentHierarcyAction = async (tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_ASSORTMENT_HIERARCY}/GetAllDepartment`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Department_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Department_fail",
        payload: error,
      });
    }
  };

  // SerchByAssortNumber API
  const searchAssortmentHierarcyAction = async (num, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_ASSORTMENT_HIERARCY}/SerchByAssortNumber?Assort_Nbr=${num}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Search_success",
          payload: res?.data,
        });

        //not found
        if (res?.data.length == 0) alert("The value is invalid");
      }
    } catch (error) {
      dispatch({
        type: "Search_fail",
        payload: error,
      });
    }
  };

  // GetAssortmentById API
  const getSingleAssortmentHierarcyAction = async (id, tokenVal) => {
    try {
      //header
      const config = {
        headers: {
          Authorization: `Bearer ${tokenVal}`,
          "Content-Type": "application/json;charset=utf-8",
          "Access-Control-Allow-Origin": "*",
          "cache-control": "no-cache",
        },
      };

      const res = await axios.get(
        `${API_URL_ASSORTMENT_HIERARCY}/GetAssortmentById?Id=${id}`, config
      );

      if (res?.request.status === 200) {
        dispatch({
          type: "Single_success",
          payload: res?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: "Single_fail",
        payload: error,
      });
    }
  };

  return (
    <assortmentHierarcyContext.Provider
      value={{
        assortment: state?.assortment,
        assortmentHierarcy: state?.assortmentHierarcy,
        error: state?.error,
        loading: state?.loading,
        fetchAssortmentHierarcyAction,
        addUpdateAssortmentHierarcyAction,
        deleteAssortmentHierarcyAction,
        getDepartmentAssortmentHierarcyAction,
        searchAssortmentHierarcyAction,
        getSingleAssortmentHierarcyAction,
        searchResult: state?.searchResult,
        departments: state?.departments,
        SingleRow: state?.SingleRow,
        rowdel: state?.rowdel,
      }}
    >
      {children}
    </assortmentHierarcyContext.Provider>
  );
};
